import { Dispatch } from 'redux';

import { RootState } from '../reducers/store';
import { GROUPS_PER_PAGE } from '../features/Customers/Details/Groups/GroupList';
import {
  CustomerGroupReponseApiType,
  CustomerGroupsReponseApiType,
  CustomerGroupBodyType,
} from 'src/features/Customers/Details/Groups/types';
import { CustomerGroupsReducerActionType } from 'src/reducers/customerGroupsReducer';

export const LIST_CUSTOMER_GROUPS = 'list_customer_groups';
export const GET_CUSTOMER_GROUP = 'get_customer_group';
export const ADD_CUSTOMER_GROUP = 'add_customer_group';
export const DELETE_CUSTOMER_GROUP = 'delete_customer_group';

export const listCustomerGroups =
  (page: number) =>
  (
    dispatch: Dispatch<CustomerGroupsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
      customers: { customerDetail },
    } = getState();

    get(
      `/customers/${customerDetail.id}/groups?page=${page}&per_page=${GROUPS_PER_PAGE}`,
      (response: CustomerGroupsReponseApiType) => {
        response.data &&
          dispatch({
            type: LIST_CUSTOMER_GROUPS,
            payload: {
              items: response.data,
              total: response.metadata?.total_count,
            },
          });
      }
    );
  };

export const getCustomerGroup =
  (id: string) =>
  (
    dispatch: Dispatch<CustomerGroupsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
    } = getState();

    get(`/groups/${id}`, (response: CustomerGroupReponseApiType) => {
      response.data &&
        dispatch({
          type: GET_CUSTOMER_GROUP,
          payload: {
            group: response.data,
          },
        });
    });
  };

export const addCustomerGroup =
  (
    body: CustomerGroupBodyType,
    successCalback: () => void,
    failureCallback: () => void
  ) =>
  async (
    dispatch: Dispatch<CustomerGroupsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { postPromise },
      customers: { customerDetail },
    } = getState();

    try {
      const groupId = await postPromise(`/groups`, body);

      await postPromise('/members', {
        source: {
          id: groupId,
          model_type: 'group',
        },
        target: {
          id: customerDetail.id,
          model_type: 'customer',
        },
      });
      listCustomerGroups(1)(dispatch, getState);
      successCalback();
    } catch (error: any) {
      error.status && failureCallback();
    }
  };

export const editCustomerGroup =
  (
    id: string,
    body: CustomerGroupBodyType,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  async (
    dispatch: Dispatch<CustomerGroupsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { patch },
    } = getState();

    patch(
      `/groups/${id}`,
      body,
      () => {
        listCustomerGroups(1)(dispatch, getState);
        successCallback();
      },
      () => failureCallback()
    );
  };

export const deleteCustomerGroup =
  (groupId: string, successCalback: () => void, failureCallback: () => void) =>
  async (
    dispatch: Dispatch<CustomerGroupsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { deletion },
    } = getState();

    deletion(
      `/groups/${groupId}`,
      {},
      () => {
        successCalback();
        dispatch({
          type: DELETE_CUSTOMER_GROUP,
          payload: {
            id: groupId,
          },
        });
      },
      failureCallback
    );
  };
